/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const FlipBackwardIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M2.5 7.50001H13.75C15.8211 7.50001 17.5 9.17894 17.5 11.25C17.5 13.3211 15.8211 15 13.75 15H10M2.5 7.50001L5.83333 4.16667M2.5 7.50001L5.83333 10.8333"
      stroke="#475467"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
